import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a13a1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-dialog" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "日期", -1))
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-item info-item-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 0,
  class: "log-empty"
}
const _hoisted_13 = {
  key: 1,
  class: "log-timeline"
}
const _hoisted_14 = { class: "log-axis" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-dot" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "log-line"
}
const _hoisted_17 = { class: "log-content" }
const _hoisted_18 = { class: "log-time" }
const _hoisted_19 = { class: "log-card" }
const _hoisted_20 = { class: "log-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "修改前预计逾期金额：", -1))
const _hoisted_22 = { class: "log-value" }
const _hoisted_23 = { class: "log-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "修改后预计逾期金额：", -1))
const _hoisted_25 = { class: "log-value" }
const _hoisted_26 = { class: "log-footer" }

import { ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { ExpectAmountRecordLogItem, ReceivableForecastItem } from './index';
import { queryExpectAmountRecordLog } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewExpectAmountLogDialog',
  props: {
    visible: { type: Boolean },
    record: null
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableForecastItem | null;
}





const loading = ref(false);
const logs = ref<ExpectAmountRecordLogItem[]>([]);

function formatAmount(value?: number | string | null) {
  if (value === null || value === undefined || value === '') return '-';
  return String(value);
}

watch(
  () => props.visible,
  async (open) => {
    if (!open) {
      logs.value = [];
      return;
    }
    await fetchLogs();
  },
);

async function fetchLogs() {
  const lDate = (props.record?.lDate || '').trim();
  const sapCustomerCode = (props.record?.customerCode || '').trim();
  if (!lDate || !sapCustomerCode) {
    message.error('缺少日期或客户编码，无法查询日志');
    logs.value = [];
    return;
  }

  loading.value = true;
  try {
    logs.value = await queryExpectAmountRecordLog({ lDate, sapCustomerCode });
  } catch (error) {
    logs.value = [];
    message.error(error instanceof Error ? error.message : '查询修改日志失败');
  } finally {
    loading.value = false;
  }
}

function handleCancel() {
  emit('update:visible', false);
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "预计逾期金额修改记录",
    width: 640,
    "mask-closable": false,
    "destroy-on-close": "",
    onCancel: handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_a_button, { onClick: handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.record?.lDate || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.record?.customerCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", {
              class: "info-value",
              title: __props.record?.customerName || '-'
            }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_11)
          ])
        ]),
        _createVNode(_component_a_spin, { spinning: loading.value }, {
          default: _withCtx(() => [
            (!loading.value && !logs.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无修改日志"))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id || index,
                      class: "log-item"
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        (index < logs.value.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createTextVNode(_toDisplayString(item.createDate || '-') + " ", 1),
                          (item.createName || item.createWorkCode)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" | " + _toDisplayString(item.createName || '-') + " ", 1),
                                (item.createWorkCode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("(" + _toDisplayString(item.createWorkCode) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, _toDisplayString(formatAmount(item.originExpectOverdueAmount)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(formatAmount(item.expectOverdueAmount)), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})